export const ACTION_CODE = 'CUSTOMER' + '_CATEGORIES' + '_ACTION';
